"use client";

import { useState } from "react";
import posthog from "posthog-js";

type ProductId = "starter" | "growth" | "lifetime";

export function useCheckout(source: string) {
  const [loadingPlan, setLoadingPlan] = useState<ProductId | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function start(productId: ProductId, email?: string) {
    setLoadingPlan(productId);
    setError(null);
    posthog.capture("checkout_started", {
      plan_type: productId,
      source,
    });

    try {
      const res = await fetch("/api/checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productId, ...(email && { email }) }),
      });

      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        const msg = `Checkout failed (HTTP ${res.status})`;
        console.error(msg, body);
        posthog.captureException(new Error(`${msg}: ${JSON.stringify(body)}`));
        setError("Couldn't start checkout. Please try again.");
        setLoadingPlan(null);
        return;
      }

      const data = (await res.json()) as { url?: string };
      if (data.url) {
        window.location.href = data.url;
        return;
      }

      console.error("Checkout response missing url");
      posthog.captureException(new Error("Checkout response missing url"));
      setError("Couldn't start checkout. Please try again.");
      setLoadingPlan(null);
    } catch (err) {
      console.error("Checkout network error:", err);
      posthog.captureException(err);
      setError("Network error. Please try again.");
      setLoadingPlan(null);
    }
  }

  return { loadingPlan, error, start };
}
